import api from 'api';
import {useDeleteApi} from 'common/hooks/useDeleteApi';
import {DialogTypes} from 'common/names';
import {useOpenSubDialog} from 'features/layout/redux/hooks/useOpenSubDialog';
import {useCallback, useRef, useState} from 'react';
import {IDiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectType} from 'types/DiplomatObjectType';

export const useDeletePermission = (refetch: () => void, objectType: string, id: string) => {
   const {request: deleteRole} = useDeleteApi(api.permissions);

   // const {addToast} = useToasts();

   const checkedItemsRef = useRef<IDiplomatObject[]>([]);
   const _onDelete = useCallback(
      (res: any) => {
         console.debug('Delete permission', res, checkedItemsRef.current);
         if (res) {
            const promises = checkedItemsRef.current.map((item) =>
               deleteRole({
                  body: JSON.stringify({
                     objectType: objectType,
                     resourceId: id,
                     userId: item.objectType === DiplomatObjectType.enum.USER ? item.id : undefined,
                     roleId:
                        item.objectType === DiplomatObjectType.enum.ADMIN_ROLE
                           ? item.id
                           : undefined,
                  }),
               })
            );
            Promise.all(promises).then(() => {
               // addToast('Selected permissions deleted successfully');
               refetch();
            });
         }
      },
      [checkedItemsRef, deleteRole, refetch]
   );

   const openDelete = useOpenSubDialog(DialogTypes.ConfirmDialog.id, {
      title: 'Delete selected?',
      onClose: _onDelete,
   });

   const onDelete = useCallback(
      (checkedItems: IDiplomatObject[]) => {
         console.debug('Request to delete permission', checkedItems);
         checkedItemsRef.current = checkedItems;
         openDelete();
      },
      [checkedItemsRef, openDelete]
   );

   return onDelete;
};
